export const currentCompanyKeySelector = state =>
  state.getIn(['app', 'company', 'currentCompany', 'companyKey']);
export const currentCompanyIdSelector = state =>
  state.getIn(['app', 'company', 'currentCompany', 'company_id']);
export const currentCompanyLogoSelector = state =>
  state.getIn(['app', 'company', 'currentCompany', 'logo']);
export const currentCompanyValidStateSelector = state =>
  state.getIn(['app', 'company', 'currentCompany', 'validState']);
export const currentCompanySyndicationStateSelector = state =>
  state.getIn(['app', 'company', 'currentCompany', 'syndicationState']);
export const currentCompanyIsPlaceholderSelector = state =>
  state.getIn(['app', 'company', 'currentCompany', 'is_placeholder']);
export const currentCompanyNameSelector = state =>
  state.getIn(['app', 'company', 'currentCompany', 'name']);
export const partnerSearchesSelector = state =>
  state.getIn(['firestore', 'data', 'partnerSearches/byBroker']);
export const currentSearchIdSelector = (state, props) =>
  state.getIn(['app', props.app || 'company', 'currentSearch', 'searchID']);
export const currentSearchLoadIdSelector = (state, props) =>
  state.getIn(['app', props.app || 'company', 'currentSearch', 'loadID']);
export const currentSearchSearchLegIdSelector = (state, props) =>
  state.getIn(['app', props.app || 'company', 'currentSearch', 'searchLegID']);
export const overrideEmailSelector = state =>
  state.getIn(['app', 'company', 'currentCompany', 'overrideEmail']);
export const overridePhoneSelector = state =>
  state.getIn(['app', 'company', 'currentCompany', 'overridePhone']);
